<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <p-card styleClass="very-compact-card p-3">
    <div class="p-fluid">
      <div class="field">
        <label class="font-medium required-field">Название</label>
        <crm-input-text
          [(value)]="type.name"
          [isError]="$any(errors?.name)"></crm-input-text>
        <small
          *ngIf="errors?.name"
          class="p-error">
          {{ errors.name | join }}
        </small>
      </div>
    </div>
  </p-card>

  <p-card styleClass="mt-3 very-compact-card p-3">
    <h3 class="mb-0">Новые поля</h3>

    <crm-table
      *ngIf="type.attributes?.length"
      [columns]="attributeColumns"
      [values]="type.attributes || []"
      styleClass="p-datatable-sm mt-2">
      <ng-template
        #rowTemplate
        let-attribute="item">
        <tr *ngIf="toAttribute(attribute) as attribute">
          <td>
            <crm-input-text
              [(value)]="attribute.name"
              class="w-full"></crm-input-text>
          </td>
          <td>
            <crm-single-select
              [options]="attributeTypes"
              [(selectedItem)]="attribute.type"
              [isTemplateCombined]="true"
              [filter]="false"
              [showClear]="true"
              dataKey="name"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-type="item">
                {{ type?.value | eavAttributeValueTypeName }}
              </ng-template>
            </crm-single-select>
          </td>
          <td class="max-w-15rem">
            <crm-multi-select
              [options]="attributeStatuses"
              [(selectedItems)]="attribute.requiredOnHdTaskStatuses"
              [maxSelectedLabels]="1"
              [showClear]="true"
              appendTo="body"></crm-multi-select>
          </td>
          <td>
            <div
              *ngIf="
                attribute.type === EavAttributeValueTypeEnum.FILIAL ||
                attribute.type === EavAttributeValueTypeEnum.COST_CENTER
              "
              class="field-checkbox mb-0">
              <p-checkbox
                [(ngModel)]="attribute.multipleSelect"
                [binary]="true"
                inputId="multipleSelect"></p-checkbox>
              <label [for]="'multipleSelect'">Множественный выбор</label>
            </div>
          </td>
          <td>
            <i
              class="pi pi-times text-red-500 hover:text-red-300 cursor-pointer"
              style="font-size: 1.3rem"
              (click)="deleteAttribute(attribute)"></i>
          </td>
        </tr>
      </ng-template>
    </crm-table>

    <div
      *ngIf="attributeErrors?.length"
      class="mb-3">
      <small class="p-error">
        {{ attributeErrors | join }}
      </small>
    </div>

    <button
      pButton
      label="Добавить"
      icon="pi pi-plus"
      class="p-button-success p-button-text mt-2"
      (click)="addAttribute()"></button>
  </p-card>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success"
        (click)="saveEavEntityType()"></button>
      <div class="flex align-items-center gap-2">
        <button
          *ngIf="(form$ | async)?.isShowDelete && !type.deleted"
          pButton
          label="Удалить"
          class="p-button-danger p-button-text"
          (click)="deleteEavEntityType()"></button>
        <button
          *ngIf="(form$ | async)?.isShowDelete && type.deleted"
          pButton
          icon="pi pi-undo"
          label="Восстановить"
          class="p-button-info p-button-text"
          (click)="restoreEavEntityType()"></button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
